<template>
    <div class="pid-container">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" size="medium">
            <el-form-item label="渠道类型" prop="type">
                <el-select v-model="ruleForm.type" placeholder="请选择活动区域" style="width: 260px;">
                    <el-option label="微信群" value="1"></el-option>
                    <el-option label="QQ群" value="2"></el-option>
                    <el-option label="微博" value="3"></el-option>
                    <el-option label="微信公众号" value="4"></el-option>
                    <el-option label="网站及其他" value="5"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="ruleForm.type === '1' ? '微信群名称' : ruleForm.type === '2' ? 'QQ群名称' : ruleForm.type === '3' ? '微博名称' : ruleForm.type === '4' ? '微信公众号名称' : '渠道名称'" prop="wxq_name">
                <el-input v-model="ruleForm.wxq_name" style="width: 260px;"></el-input>
                <span class="prompt-text">(自填，建议和联盟设置的一样且小于10个字符）</span>
            </el-form-item>
            <el-form-item :label="ruleForm.type === '1' ? '微信群ID' : ruleForm.type === '2' ? 'QQ群ID' : ruleForm.type === '3' ? '微博ID' : ruleForm.type === '4' ? '公众号帐号' : '渠道ID'" prop="wxq_id">
                <el-input v-model="ruleForm.wxq_id" style="width: 260px;"></el-input>
            </el-form-item>
            <el-form-item :label="ruleForm.type === '1' ? '微信群人数' : ruleForm.type === '2' ? 'QQ群人数' : ruleForm.type === '3' ? '微博粉丝数' : ruleForm.type === '4' ? '公众号粉丝数' : '渠道粉丝数'" prop="wxq_num">
                <el-input v-model="ruleForm.wxq_num" style="width: 260px;"></el-input>
            </el-form-item>
            <el-form-item label="推广链接或PID" prop="link">
                <el-input v-model="ruleForm.link" style="width: 260px;"></el-input>
                <span class="prompt-text">(示例：10011550_2325296_9002527，或输入商品推广链接可自动获取）</span>
            </el-form-item>
            <el-form-item>
                <el-button class="btn-orange" size="medium" @click="submitForm('ruleForm')">添加渠道</el-button>
                <router-link to="/student/productPromotion/PIDTao" target="_blank" style="color: #FE4800; margin-left: 16px">点击查看教程？</router-link>
            </el-form-item>
        </el-form>
        <el-table :data="PIDList" style="width: 100%; margin-top: 35px;" size="mini" max-height="200px"
                  :header-cell-style="{fontWeight: 'normal', color: '#333', background: '#EFEEFF'}"
                  :cell-style="{fontSize: '12px',color: '#333'}">
            <el-table-column label="渠道类型" align="center">
                <template slot-scope="scope">
                    {{scope.row.type === '1' ? '微信群' : scope.row.type === '2' ? 'QQ群' : scope.row.type === '3' ? '微博' : scope.row.type === '4' ? '微信公众号' : '网站及其他'}}
                </template>
            </el-table-column>
            <el-table-column prop="wxq_name" label="渠道名称" align="center"></el-table-column>
            <el-table-column prop="wxq_id" label="渠道ID" align="center"></el-table-column>
            <el-table-column prop="wxq_num" label="粉丝数" align="center"></el-table-column>
            <el-table-column prop="link" label="渠道三段式PID" align="center" min-width="200px"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-link :underline="false" class="link-blue" @click="editBtn(scope.row)">修改</el-link>
                    <el-link :underline="false" type="danger" @click="delBtn(scope.row.id)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <div class="yellow-prompt">PID务必正确，否则您得不到任何佣金哦！</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ruleForm: {
                    id: null,
                    type: '1',
                    wxq_name: '',
                    wxq_id: '',
                    wxq_num: '',
                    link: '',
                },
                rules: {
                    type: [
                        { required: true, message: '请选择渠道类型', trigger: 'change' }
                    ],
                    wxq_name: [
                        { required: true, message: '请输入渠道类型', trigger: 'blur' },
                        { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
                    ],
                    wxq_id: [
                        { required: true, message: '请输入微信群ID', trigger: 'blur' }
                    ],
                    wxq_num: [
                        { required: true, message: '请输入微信群人数', trigger: 'blur' }
                    ],
                    link: [
                        { required: true, message: '请输入推广链接或PID', trigger: 'blur' }
                    ],
                },
                PIDList: []
            }
        },
        mounted() {
            this.getPIDList()
        },
        methods: {
            getPIDList() {
                let params = {
                    mode: 'tb'
                }
                this.$httpStudent.axiosGetBy(this.$api.setList, params, (res) => {
                    if (res.code === 200) {
                        this.PIDList = res.data
                    } else {
                        this.$message.warning(res.message)
                    }
                }, (err) => {
                    console.log(err)
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let formData = new FormData()
                        formData.append('mode', 'tb')
                        formData.append('type', this.ruleForm.type)
                        formData.append('wxq_name', this.ruleForm.wxq_name)
                        formData.append('wxq_id', this.ruleForm.wxq_id)
                        formData.append('wxq_num', this.ruleForm.wxq_num)
                        formData.append('link', this.ruleForm.link)
                        if (this.ruleForm.id) {
                            formData.append('id', this.ruleForm.id)
                        }
                        this.$httpStudent.axiosPost(this.$api.setSave, formData, (res) => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.clearForm()
                                this.getPIDList()
                            } else {
                                this.$message.warning(res.message)
                            }
                        }, (err) => {
                            console.log(err)
                        })
                    } else {
                        return false;
                    }
                });
            },
            editBtn(row) {
                this.ruleForm = JSON.parse(JSON.stringify(row))
            },
            delBtn(id) {
                this.$confirm('是否删除该PID，删除之后将无法恢复', '提示消息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    confirmButtonClass: 'blue-btn',
                    type: 'warning',
                }).then(() => {
                    this.$httpStudent.axiosGetBy(this.$api.setDel, {id: id}, (res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message)
                            this.getPIDList()
                        } else {
                            this.$message.warning(res.message)
                        }
                    }, (err) => {
                        console.log(err)
                    })
                }).catch(() => {
                    this.$message.info('已取消删除')
                });
            },
            clearForm() {
                this.$refs['ruleForm'].resetFields();
                this.ruleForm = {
                    id: null,
                    type: '1',
                    wxq_name: '',
                    wxq_id: '',
                    wxq_num: '',
                    link: '',
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .pid-container {
        padding: 30px 20px 90px;
        position: relative;
        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 20px;
            right: 20px;
            height: 1px;
            background: #ddd;
        }
    }
    .prompt-text {
        margin-left: 10px;
        color: #666;
    }
    .el-link + .el-link {
        margin-left: 10px;
    }
    .yellow-prompt {
        margin-top: 1px;
        color: #666;
        font-size: 12px;
        background: #FCF8E3;
        text-align: center;
        padding: 10px 0;
    }
</style>